import {
  BODY_SKINS,
  CELL_SIZE,
  DIRECTION_LEFT,
  DIRECTION_RIGHT,
  DIRECTION_UP,
  LAYERS,
} from "../helpers/consts";

export class Placement {
  constructor(properties, level) {
    this.level = level;
    this.id = properties.id;
    this.type = properties.type;
    this.x = properties.x;
    this.y = properties.y;

    this.travelPixelsPerFrame = 1.5;
    this.movingPixelsRemaining = 0;
    this.movingPixelDirection = DIRECTION_RIGHT;

    this.hasBeenCollected = false;
    this.wasSpawnedAfterMapStart = false;
    this.jsonSavingOverrides = {};
  }

  tick() {
    return null;
  }

  appearsOnScreen() {
    return !this.hasBeenCollected;
  }

  getEditingLayer() {
    return LAYERS.TILES;
  }

  isOnlyType() {
    return false;
  }

  spawnPlacementOnStart() {
    return null;
  }

  isSolid() {
    return false;
  }

  givesPreAutoMoveFrames(_forBody) {
    return 0;
  }

  switchesWallsOnCollide() {
    return false;
  }

  playSfxOnCollect() {
    return null;
  }

  addsItemToInventoryOnCollide() {
    return null;
  }

  teleportsToPositionOnUnlock() {
    return null;
  }

  changeHeroSkinOnCollide() {
    return BODY_SKINS.NORMAL;
  }

  completesLevelOnCollide() {
    return false;
  }

  resetsInventoryOnCollide() {
    return false;
  }

  allowsMovingInDirection() {
    return true;
  }

  canBeStolen() {
    return false;
  }

  dropsBulletOnCollide() {
    return false;
  }

  damagesBodyOnCollide() {
    return false;
  }

  getZIndex() {
    return 1;
  }

  displayXY() {
    if (this.movingPixelsRemaining > 0) {
      return this.displayMovingXY();
    }
    const x = this.x * CELL_SIZE;
    const y = this.y * CELL_SIZE;
    return [x, y];
  }

  displayMovingXY() {
    // Compute position by adding/removing pixels from position we are moving away from
    const x = this.x * CELL_SIZE;
    const y = this.y * CELL_SIZE;
    const progressPixels = CELL_SIZE - this.movingPixelsRemaining;
    switch (this.movingPixelDirection) {
      case DIRECTION_LEFT:
        return [x - progressPixels, y];
      case DIRECTION_RIGHT:
        return [x + progressPixels, y];
      case DIRECTION_UP:
        return [x, y - progressPixels];
      default:
        return [x, y + progressPixels];
    }
  }

  toJSON() {
    return {
      type: this.type,
      x: this.x,
      y: this.y,

      // Keys that may appear (undefined values will be stripped out)
      direction: this.direction ?? undefined,
      color: this.color ?? undefined,
      corner: this.corner ?? undefined,
      isRaised: this.isRaised ?? undefined,
      enemyType: this.enemyType ?? undefined,

      // Save initial state for objects that change (like Switches)
      ...this.jsonSavingOverrides,
    };
  }
}
